<template>
  <div v-if="!loading" style="height:100%; overflow: hidden;">
    <vue-flux :options="fluxOptions" :images="fluxImages" 
    :transitions="fluxTransitions" width="100%" height="100%"
      type="relative" ref="slider">
      <!-- <flux-pagination slot="pagination"></flux-pagination> -->
    </vue-flux>
  </div>
</template>
<script>
import { VueFlux, Transitions } from 'vue-flux';
import adImageService from '@/modules/MasjidImage/service'

export default {
  components: {
    VueFlux,
  },
  data: () => ({
    loading: false,
    fluxOptions: {
      autoplay: true,
      fullscreen: true,
      delay: 30000,
    },
    fluxImages: [],
    fluxTransitions: {
      transitionBlinds2d: Transitions.transitionBlinds2d,
      transitionBlinds3d: Transitions.transitionBlinds3d,
      transitionBlocks1: Transitions.transitionBlocks1,
      transitionBlocks2: Transitions.transitionBlocks2,
      transitionBook: Transitions.transitionBook,
      transitionCamera: Transitions.transitionCamera,
      transitionConcentric: Transitions.transitionConcentric,
      transitionCube: Transitions.transitionCube,
      transitionExplode: Transitions.transitionExplode,
      transitionFade: Transitions.transitionFade,
      transitionFall: Transitions.transitionFall,
      transitionKenburn: Transitions.transitionKenburn,
      transitionRound1: Transitions.transitionRound1,
      transitionRound2: Transitions.transitionRound2,
      transitionSlide: Transitions.transitionSlide,
      transitionSwipe: Transitions.transitionSwipe,
      transitionWarp: Transitions.transitionWarp,
      transitionWaterfall: Transitions.transitionWaterfall,
      transitionWave: Transitions.transitionWave,
      transitionZip: Transitions.transitionZip,
    },
  }),
  sockets: {
    updateAdList() {
      console.log('updateAdList')
      this.getAllListAds();
    }
  },
  methods: {
    getAllListAds() {
      this.loading = true
      this.fluxImages = []
      adImageService.noTokenGetAllListAds({ isActive: true }).then((response) => {
        console.log('response', response)
        response.map((row) => {
          this.fluxImages.push(row.url)
        })
        this.loading = false
        // this.fluxImages = response
        // this.loading = false
      })
    },
  },
  created() {
    this.getAllListAds()
  },
}
</script>
<style>
body::-webkit-scrollbar {
  display: none;
}
</style>
